/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Value_Label_InlineInputs */

const en_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value:`)
};

const fr_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur :`)
};

const de_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert:`)
};

const it_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore:`)
};

const ru_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ценить:`)
};

const es_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor:`)
};

const zh_cn2_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价值：`)
};

const ja_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価値：`)
};

const hi_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कीमत:`)
};

const pt_pt2_options_metadata_value_label_inline = /** @type {(inputs: Options_Metadata_Value_Label_InlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor:`)
};

/**
* | output |
* | --- |
* | "Value:" |
*
* @param {Options_Metadata_Value_Label_InlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_value_label_inline = /** @type {((inputs?: Options_Metadata_Value_Label_InlineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Value_Label_InlineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_metadata_value_label_inline(inputs)
	if (locale === "de") return de_options_metadata_value_label_inline(inputs)
	if (locale === "it") return it_options_metadata_value_label_inline(inputs)
	if (locale === "ru") return ru_options_metadata_value_label_inline(inputs)
	if (locale === "es") return es_options_metadata_value_label_inline(inputs)
	if (locale === "zh-CN") return zh_cn2_options_metadata_value_label_inline(inputs)
	if (locale === "ja") return ja_options_metadata_value_label_inline(inputs)
	if (locale === "hi") return hi_options_metadata_value_label_inline(inputs)
	if (locale === "pt-PT") return pt_pt2_options_metadata_value_label_inline(inputs)
	return en_options_metadata_value_label_inline(inputs)
});